import React, { useContext, useState } from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { PropsFromRedux } from '.';
// import { BeatLoader } from '../Spinners/Spinner';
// import { API_KEYS } from '../../interfaces/api';
import TextInput from '../form-controls/TextInput';
import { useShippingFormContext } from '../../context/ShippingFormContext/context';
import { SHIPPING_FORM_TYPES } from '../../context/ShippingFormContext/reducer';

interface Props extends PropsFromRedux {}

interface Inputs {
    CodAmount: number;
}

const schema = yup.object().shape({
    CodAmount: yup.number().required(),
})

const CodAmountModal: React.FC<Props> = ({ 
    hideModal,
    showModal,
    modal,
    resetApi
}) => {
const { formState, dispatch } = useShippingFormContext();
const [codAmount, setCodAmount] = React.useState({});
const closeModal = () => {
    hideModal();
};

const onSubmit = async (data: Inputs) => {
    // setCodAmount(data);
    dispatch({
      type: SHIPPING_FORM_TYPES.UPDATE_VALUE,
      values: {
        IsCashOnDelivery : true,
        CashOnDeliveryAmount : parseInt(amount, 10)
      }
    })
    hideModal();
}



const { handleSubmit, control, errors, reset, watch, setValue } = useForm<Inputs>({
    resolver: yupResolver(schema),
    defaultValues : {
      CodAmount : formState?.values?.CashOnDeliveryAmount
    }
});

const amount : any = watch('CodAmount');

return(
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
    <div className="w-full px-2 bg-white lg:px-6 py-10 relative">
       <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
     <div className="w-full my-2 text-center">
         <h5 className="mb-1 text-md font-bold text-black">Cod Amount</h5>
      </div>
      <div className="w-full mt-12 mb-6 text-sm">
      <div className="mb-2 text-sm text-gray-500 font-medium">
      <Controller
        name="CodAmount"
        control={control}
        defaultValue=""
        render={({ name, value, onChange }) => (
          <TextInput
            name={name}
            value={value}
            className="border-gray-300 border p-3 w-full rounded"
            id={name}
            labelClassName="mb-2 text-xs flex"
            label="Enter COD Amount"
            type="number"
            wrapperClassName="w-full"
            error={errors['CodAmount']}
            placeholder="Enter cod amount "
            customChange={onChange}
          />
        )}
      />
    </div>
    <p className="w-full mb-6">
    This amount would be received by our rider or delivery partner.
    </p>
      </div>
        <button className="w-full bg-black rounded font-medium text-sm my-8 uppercase rounded-sm text-white py-4" type="submit">
             Save
        </button>
  </div>
  </form>
  );
}

export default CodAmountModal;